import FormattedMessage from 'I18n/components/FormattedMessage';
import { ResultsMessage } from 'foundations-components/transitional/components/ResultsMessage';
import { Table } from 'foundations-components/transitional/components/Table';
import styled from 'styled-components';
import AccountRow from './AccountRow';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FixedWidthNameCol = styled.col.withConfig({
  displayName: "AccountTable__FixedWidthNameCol",
  componentId: "pmtx7e-0"
})(["width:350px;"]);
const FixedWidthDetailsCol = styled.col.withConfig({
  displayName: "AccountTable__FixedWidthDetailsCol",
  componentId: "pmtx7e-1"
})(["width:275px;"]);
const FixedWidthDiv = styled.div.withConfig({
  displayName: "AccountTable__FixedWidthDiv",
  componentId: "pmtx7e-2"
})(["position:relative;width:625px;display:table-cell;"]);
const AccountTable = ({
  accounts,
  selectedAccount,
  setSelectedAccount,
  appName
}) => {
  if (accounts.length === 0) {
    return /*#__PURE__*/_jsx(FixedWidthDiv, {
      children: /*#__PURE__*/_jsx(ResultsMessage, {
        illustration: "empty-state-charts",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-experience-shared-components.accountPicker.table.empty"
        })
      })
    });
  }
  return /*#__PURE__*/_jsxs(Table, {
    children: [/*#__PURE__*/_jsxs("colgroup", {
      children: [/*#__PURE__*/_jsx(FixedWidthNameCol, {}), /*#__PURE__*/_jsx(FixedWidthDetailsCol, {}), /*#__PURE__*/_jsx("col", {})]
    }), /*#__PURE__*/_jsx("thead", {
      children: /*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "developer-experience-shared-components.accountPicker.table.name"
          })
        }), /*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "developer-experience-shared-components.accountPicker.table.details"
          })
        })]
      })
    }), /*#__PURE__*/_jsx("tbody", {
      children: accounts.map(account => {
        const isSelected = (selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.portalId) === account.portalId;
        return /*#__PURE__*/_jsx(AccountRow, {
          disabled: account.disabled,
          account: account,
          isSelected: isSelected,
          onSelect: setSelectedAccount,
          appName: appName
        }, account.portalId);
      })
    })]
  });
};
export default AccountTable;